module.exports = __webpack_public_path__ + "img/addOnNew.db7d108a.svg";